module.exports = __webpack_public_path__ + "img/logo-vertical-white.038e6d7f.svg";